const state = {
    starMapDetail: {},
    mipApiList: [],
}

export default state
